import {Entity} from '../base/entity';
import {Item} from '../lookups/item';
import {isNil} from 'lodash';

export class SpecifikacijaItem extends Entity {

  public static readonly TABLENAME = 'specifikacija_item';

  public static readonly ID = 'id';
  public static readonly SPECIFIKACIJA_ID = 'specifikacija_id';
  public static readonly ITEM_ID = 'item_id';

  id: number;
  specifikacijaId: number;
  itemId: string;

  item: Item;

  constructor(jsonObj: any) {
    super(jsonObj);

    if (!isNil(jsonObj)) {
      this.item = !isNil(jsonObj.item) ? new Item(jsonObj.item) : null;
    }
  }
}
